import React from 'react'
import './Clientlist.css'
import qticket from '../../../../assets/img/qtickets.webp'
import qatarday from '../../../../assets/img/qatarday.webp'
import citycenter from '../../../../assets/img/city_center.webp'
import monoprix from '../../../../assets/img/monoprix.webp'
import tourism from '../../../../assets/img/qatar_tourism.webp'
import culture from '../../../../assets/img/qatar_culture.webp'
import bpo from '../../../../assets/img/bpo.webp'
import nandos from '../../../../assets/img/nandos.webp'
import karak from '../../../../assets/img/karak.webp'
import play from '../../../../assets/img/360play.webp'
import diet from '../../../../assets/img/diet_delight.webp'
import kc from '../../../../assets/img/Katara_cinema.webp'
import oq from '../../../../assets/img/qoc.webp'
import na from '../../../../assets/img/naseem_alrabeeh.webp'
import mcp from '../../../../assets/img/mcp.webp'
import mc from '../../../../assets/img/mannai_corporation.webp'
import hsb from '../../../../assets/img/hilton_salwa_beach.webp'
import qa from '../../../../assets/img/qatar_airways.webp'
import qr from '../../../../assets/img/qatar_rail.webp'
import qfa from '../../../../assets/img/qfa.webp'
import qatarcyclist from '../../../../assets/img/qatar_cyclist.webp'
import cinepolis from '../../../../assets/img/cinepolis.webp'
import qca from '../../../../assets/img/qca.webp'
import alfaisal from '../../../../assets/img/alfaisal_holding.webp'
import coastalqatar from '../../../../assets/img/coastal_qatar.webp'
import qatarcinema from '../../../../assets/img/qatar_cinema.webp'
import nourish from '../../../../assets/img/nourish.webp'
import aamalmed from '../../../../assets/img/amalmedical.webp'
import stc from '../../../../assets/img/stc.webp'
import qpo from '../../../../assets/img/qpo.webp'
import aljazi from '../../../../assets/img/aljazi_logo.webp'



function Clientlist() {

    const cliensimg = [
        {
            img: qticket
        },
        {
            img: qatarday
        },
        {
            img: citycenter
        },
        {
            img: monoprix
        },
        {
            img: tourism
        },
        {
            img: culture
        },
        {
            img: aljazi
        },
        {
            img: bpo
        },
        {
            img: nandos
        },
        {
            img: karak
        },
        {
            img: play
        },
        {
            img: diet
        },
        {
            img: kc
        },
        {
            img: oq
        },
        {
            img: na
        },
        {
            img: mcp
        },
        {
            img: mc
        },
        {
            img: hsb
        },
        {
            img: qa
        },
        {
            img: qr
        },
        {
            img: qfa
        },
        {
            img: qatarcyclist
        },
        {
            img: cinepolis
        },
        {
            img: qca
        },
        {
            img: alfaisal
        },
        {
            img: coastalqatar
        },
        {
            img: qatarcinema
        },
        {
            img: nourish
        },
        {
            img: aamalmed
        },
        {
            img: stc
        },
        {
            img: qpo
        }
    ]

  return (
    <section className='client-sec'>
        <div className='container'>
            <ul>
                {
                  cliensimg.map((Clientlist, index)=> (
                    <li key={index}>
                        <img src={Clientlist.img} alt='Client logo' width={180} height={80} loading="lazy"/>
                    </li>    
                  ))  
                }
                
            </ul>
        </div>
    </section>
  )
}

export default Clientlist
